import { Rank as API } from '@src/api/types';
import { Rank as Data } from '@src/types';

import generateUser from './user';

const Factory = (api: API): Data => ({
  index: api.index,
  score: api.score,
  user: generateUser(api.user),
});

export default Factory;
